<template>
  <div class="forestMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <van-cell-group class="forestInput" v-if="!showNonePage">
      <van-field
        :value="baseData.address ? baseData.address : $t('common.noneText')"
        readonly
        :label="$t('common.location') + '：'"
      />
      <van-field
        :value="baseData.xiaoBan ? baseData.xiaoBan : $t('common.noneText')"
        readonly
        :label="$t('common.xiaobanTit') + '：'"
      />
      <van-field
        :value="baseData.mianJi ? baseData.mianJi : $t('common.noneText')"
        readonly
        :label="$t('common.mianjiTit') + '：'"
      />
      <van-field
        :value="baseData.ldQs ? baseData.ldQs : $t('common.noneText')"
        readonly
        :label="$t('common.ldQsTit') + '：'"
      />
      <van-field
        :value="baseData.diLei ? baseData.diLei : $t('common.noneText')"
        readonly
        :label="$t('common.dileiTit') + '：'"
      />
      <van-field
        :value="baseData.linZhong ? baseData.linZhong : $t('common.noneText')"
        readonly
        :label="$t('common.linzhongTit') + '：'"
      />
      <van-field
        :value="baseData.qiYuan ? baseData.qiYuan : $t('common.noneText')"
        readonly
        :label="$t('common.qiyuanTit') + '：'"
      />
      <van-field
        class="lbStyle"
        :value="baseData.senLinLb ? baseData.senLinLb : $t('common.noneText')"
        readonly
        :label="$t('common.senLinLbTit') + '：'"
      />
      <van-field
        :value="baseData.shiQuanD ? baseData.shiQuanD : $t('common.noneText')"
        readonly
        :label="$t('common.shiQuanDTit') + '：'"
      />
      <van-field
        :value="baseData.gjgylBhdj ? baseData.gjgylBhdj : $t('common.noneText')"
        readonly
        :label="$t('common.gjgylBhdjTit') + '：'"
      />
      <van-field
        :value="baseData.lingZu ? baseData.lingZu : $t('common.noneText')"
        readonly
        :label="$t('common.lingzuTit') + '：'"
      />
      <van-field
        :value="baseData.youShiSz ? baseData.youShiSz : $t('common.noneText')"
        readonly
        :label="$t('common.youShiSzTit') + '：'"
      />
      <van-field
        :value="baseData.zlDj ? baseData.zlDj : $t('common.noneText')"
        readonly
        :label="$t('common.zlDjTit') + '：'"
      />
      <!-- <van-field :value="baseData.bcld" readonly label="补充林地：" /> -->
      <van-field
        :value="baseData.qykz ? baseData.qykz : $t('common.noneText')"
        readonly
        :label="$t('common.qykzTit') + '：'"
      />
      <van-field
        :value="baseData.gllx ? baseData.gllx : $t('common.noneText')"
        readonly
        :label="$t('common.gllxTit') + '：'"
      />
    </van-cell-group>
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "forestMsg",
  data() {
    return {
      showNonePage: true,
      forestId: "",
      baseData: {},
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.forestId = this.$route.query.commonId;
      if (this.forestId == undefined) {
        this.forestId = this.dataInfo.id;
      }
      this.initPage();
    });
  },

  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal.forest
        .forestMsg(_this.forestId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.forestId = this.dataInfo.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.forestMsgPage {
  width: 100%;
  > p.fgx {
    width: 100%;
    height: 5px;
    background-color: #f6f6f6;
  }
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>